// TODO: substituir quando endpoint for criado no backend
// Backend não tem endpoint de série temporal.
// Calculado localmente via GET /sessions quando disponível.
// Este mock é usado apenas como fallback quando sessions estiver vazio.

export interface BankrollPoint {
  week: string;
  lucro: number;
  ev: number;
}

export const mockBankrollHistory: BankrollPoint[] = [
  { week: 'Sem 1', lucro: 0, ev: 0 },
  { week: 'Sem 2', lucro: 120, ev: 150 },
  { week: 'Sem 3', lucro: 80, ev: 200 },
  { week: 'Sem 4', lucro: 310, ev: 380 },
  { week: 'Sem 5', lucro: 250, ev: 420 },
  { week: 'Sem 6', lucro: 480, ev: 530 },
];
